import { BUY_TOUCHLESS, TALK_TO_SALES, TRIAL } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useAppSelector } from '../../../reducers';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { purchaseMotionsSelector } from '../../../selectors/PurchaseMotionSelectors';
export const useBundledProductPurchaseMotions = ({
  skuId
}) => {
  const isAppReady = useGlobalLoading();
  const purchaseMotions = useAppSelector(state => {
    if (!isAppReady || !skuId) return [];
    return purchaseMotionsSelector(state, {
      skuId
    });
  });
  const isAppAuth = useAppSelector(isAppAuthSelector);
  if (isAppAuth) {
    return purchaseMotions;
  }

  // public purchase motions are always 1 button unless trial exist in the array, then show all the buttons
  if (purchaseMotions.includes(TRIAL)) return purchaseMotions;
  if (purchaseMotions.includes(BUY_TOUCHLESS)) return [BUY_TOUCHLESS];
  return [TALK_TO_SALES];
};